module.exports = __webpack_public_path__ + "media/images/partners/moov-africa-e665b179e8206e834e8301682aecf1d5.jpeg";